import React from 'react'
import {SvgIcon, SvgIconProps} from '@mui/material'

const AddToWatchlistIconSvg = (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fill="currentColor"
            d="M23 13h-1V4H6v19.476L14 20l3.008 1.307-.42.907L14 21.09 5 25V3h18zm0 6h4v1h-4v4h-1v-4h-4v-1h4v-4h1zm-6-3H9v-1h8zm2-4H9v-1h10zm0-4.005H9v-1h10z"
        />
    </svg>
)
const AddToWatchlistIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props} style={{fontSize: '40px'}}>
        {AddToWatchlistIconSvg}
    </SvgIcon>
)
export default AddToWatchlistIcon
